import { isFunction } from '../guards'

import type { AnalyticEvent, AnalyticsEventName } from './events'
import { getRegistrationAnalyticsEventParams } from './registration-analytics-context'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type EventParameters = Record<string, any> | null

export type AnalyticsService = {
  logEvent(name: AnalyticsEventName, parameters: EventParameters): void
  setGlobalData?(data: EventParameters): void
}

export class Composite {
  private providers: AnalyticsService[] = []
  private site: GLOBALS.Region | null = null
  private userId: string | null = null

  constructor(providers: AnalyticsService[]) {
    this.providers = providers
  }

  addProvider(provider: AnalyticsService) {
    this.providers.push(provider)
  }

  setUserSite(site: GLOBALS.Region) {
    this.site = site
  }

  setUserId(userId: string) {
    this.userId = userId
  }

  logEventWithCondition(condition: boolean, event: AnalyticEvent) {
    if (!condition) {
      return
    }

    this.logEvent(event)
  }

  logEvent(event: AnalyticEvent): void {
    const parameters: EventParameters = {
      ...(this.site && { site: this.site }),
      ...getRegistrationAnalyticsEventParams(),
      ...(event.parameters ?? {}),
    }
    this.providers.forEach((provider) => {
      provider.logEvent(event.name, parameters)
    })
  }

  setGlobalData(data: EventParameters) {
    this.providers.forEach((provider) => {
      if (isFunction(provider.setGlobalData)) {
        provider.setGlobalData(data)
      }
    })
  }
}
